module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qleg6-27daea85bf7779068c8adc3d1ad26f59.jpg";